export const typeMaterialFinish =
    [

        {
            value: 'Bare-Metal Finish', title: 'Bare-Metal Finish', label: 'Bare-Metal Finish', name: 'bareMetal'
        },
        {
            value: 'Powdercoat Finish', title: 'Powdercoat Finish', label: 'Powdercoat Finish', name: 'powderCoat'
        },

    ]

export const typeMaterialFinishBareMetal =
    [
        { title: 'No Finish', name: 'noFinish' },
        { title: 'Vibratory Finish', name: 'vibratoryFinish' },
        { title: 'Media Blasting', name: 'mediaBlasting' },
        { title: 'Grained Finish', name: 'grainedFinish' },

    ]

export const typeMaterialFinishPowderCoat = [
    {
        id: 1,
        href: "https://www.protocase.com/images/color/RAL-3020-Traffic-Red-Smooth-Glossy.jpg",
        title: "RAL 3020 Traffic Red - Glossy  - Polyester Powder",
        name: "RAL 3020 Traffic Red - Glossy  - Polyester Powder",

    },
    {
        id: 2,
        href: "https://www.protocase.com/images/color/RAL-3005-Wine-Red.jpg",
        title: "RAL 3005 Wine Red - Smooth Glossy  - Polyester Powder",
        name: "RAL 3005 Wine Red - Smooth Glossy  - Polyester Powder",

    },
    {
        id: 3,
        href: "https://www.protocase.com/images/color/RAL5010-GentianBlue(Textured).gif",
        title: "RAL 5010 Genetian Blue - Low Gloss  - Sandtex Polyester Powder",
        name: "RAL 5010 Genetian Blue - Low Gloss  - Sandtex Polyester Powder"
    },



    {
        id: 4,
        href: "https://www.protocase.com/images/color/RAL5017-TrafficBlue.gif",
        title: "RAL 5017 Traffic Blue - High Gloss  - Smooth Polyester Powder",
        name: "RAL 5017 Traffic Blue - High Gloss  - Smooth Polyester Powder"
    },



    {
        id: 5,
        href: "https://www.protocase.com/images/color/AeroYellow(SmoothSemigloss).gif",
        title: "Aero yellow - High Gloss - Smooth Polyester Powder",
        name: "Aero yellow - High Gloss - Smooth Polyester Powder"
    },




    {
        id: 6,
        href: "https://www.protocase.com/images/color/RAL-1003-Signal-Yellow-Smooth-Glossy.jpg",
        title: "RAL 1003 Signal Yellow - Smooth Glossy - Polyester Powder",
        name: "RAL 1003 Signal Yellow - Smooth Glossy - Polyester Powder"
    },

    {
        id: 7,
        href: "https://www.protocase.com/images/color/RAL6018-YellowGreen.gif",
        title: "RAL 6018 Yellow-Green - High Gloss - Smooth Polyester Powder",
        name: "RAL 6018 Yellow-Green - High Gloss - Smooth Polyester Powder"
    },



    {
        id: 8,
        href: "https://www.protocase.com/images/color/RAL6002-LeafGreen.gif",
        title: "RAL 6002 Leaf Green - High Gloss - Smooth Polyester Powder",
        name: "RAL 6002 Leaf Green - High Gloss - Smooth Polyester Powder"
    },


    {
        id: 9,
        href: "https://www.protocase.com/images/color/RAL6003-OliveGreen.gif",
        title: "RAL 6003 Olive Green - High Gloss - Smooth Polyester Powder",
        name: "RAL 6003 Olive Green - High Gloss - Smooth Polyester Powder"
    },

    {
        id: 10,
        href: "https://www.protocase.com/images/color/Black(SmoothMatte).gif",
        title: "Proto-Stock Matte Black - Low Gloss - Smooth Hybrid Powder",
        name: "Proto-Stock Matte Black - Low Gloss - Smooth Hybrid Powder"
    },


    {
        id: 11,
        href: "https://www.protocase.com/images/color/BlackSandtex.gif",
        title: "Black Sandtex - Low Gloss - Sandtex Polyester Powder",
        name: "Black Sandtex - Low Gloss - Sandtex Polyester Powder"
    },



    {
        id: 12,
        href: "https://www.protocase.com/images/color/Black(SmoothSemiGloss).gif",
        title: "RAL 9005 Jet Black - Medium Gloss - Smooth Polyester-Epoxy Blend (Hybrid)",
        name: "RAL 9005 Jet Black - Medium Gloss - Smooth Polyester-Epoxy Blend (Hybrid)"
    },


    {
        id: 13,
        href: "https://www.protocase.com/images/color/FS-17038-Black-Full-Gloss.jpg",
        title: "FS 17038 Black - Full Gloss - Smooth Polyester Powder",
        name: "FS 17038 Black - Full Gloss - Smooth Polyester Powder"
    },



    {
        id: 14,
        href: "https://www.protocase.com/images/color/FS-37038-Flat-Black.jpg",
        title: "FS 37038 Flat Black - Flat - Smooth Flat Epoxy Powder",
        name: "FS 37038 Flat Black - Flat - Smooth Flat Epoxy Powder"
    },


    {
        id: 15,
        href: "https://www.protocase.com/images/color/SafetyOrange.gif",
        title: "Safety Orange - High Gloss - Smooth Polyester Powder",
        name: "Safety Orange - High Gloss - Smooth Polyester Powder"
    },


    {
        id: 16,
        href: "https://www.protocase.com/images/color/RAL3002Textured.jpg",
        title: "RAL 3002 Carmine Red - Low Gloss - Sandtex Hybrid Powder",
        name: "RAL 3002 Carmine Red - Low Gloss - Sandtex Hybrid Powder"
    },


    {
        id: 17,
        href: "https://www.protocase.com/images/color/FireRed(SmoothSemiGloss).gif",
        title: "Fire Red - High Gloss - Smooth Hybrid Powder",
        name: "Fire Red - High Gloss - Smooth Hybrid Powder"
    },
    {
        id: 18,
        href: "https://www.protocase.com/images/color/FireRed(SmoothSemiGloss).gif",
        title: "Fire Red - High Gloss - Smooth Hybrid Powder",
        name: "Fire Red - High Gloss - Smooth Hybrid Powder"
    },

    {
        id: 19,
        href: "https://www.protocase.com/images/color/StormWhite(textured).gif",
        title: "Storm White Sandtex - Low  Gloss - Textured Polyester Powder",
        name: "Storm White Sandtex - Low  Gloss - Textured Polyester Powder"
    },
    {
        id: 20,
        href: "https://www.protocase.com/images/color/WhiteSandex.gif",
        title: "White Sandtex - Medium  Gloss - Textured Polyester Powder",
        name: "White Sandtex - Medium  Gloss - Textured Polyester Powder"
    },
    {
        id: 21,
        href: "https://www.protocase.com/images/color/Almond(SmoothSemiGloss).gif",
        title: "Almond - High Gloss - Smooth Polyester Powder",
        name: "Almond - High Gloss - Smooth Polyester Powder"
    },


    {
        id: 22,
        href: "https://www.protocase.com/images/color/SignalWhite2.jpg",
        title: "RAL 9003 Signal White - Glossy - Smooth Polyester Powder",
        name: "RAL 9003 Signal White - Glossy - Smooth Polyester Powder"
    },




    {
        id: 23,
        href: "https://www.protocase.com/images/color/BeigeWheat.gif",
        title: "Wheat - Low Gloss - Sandtex Polyester Powder",
        name: "Wheat - Low Gloss - Sandtex Polyester Powder"
    },
    {
        id: 24,
        href: "https://www.protocase.com/images/color/CO31-WH120-White-Texture.jpg",
        title: "C031-WH120 White Texture - Semi-Gloss - Smooth Polyester Powder",
        name: "C031-WH120 White Texture - Semi-Gloss - Smooth Polyester Powder"
    },
    {
        id: 25,
        "href": "https://www.protocase.com/images/color/Federal-Standard-595-Color-FS-27722-White.svg",
        "title": "Federal Standard 595 - FS 27722 - Smooth Semi Gloss Polyester Powder",
        "name": "Federal Standard 595 - FS 27722 - Smooth Semi Gloss Polyester Powder"
    },
    {            
        id: 26,
        href: "https://www.protocase.com/images/color/FS-33446-Desert-Tan.jpg",
        title: "FS 33446 Desert Tan - Flat - Smooth Polyester Powder",
        name: "FS 33446 Desert Tan - Flat - Smooth Polyester Powder"
    },
    {
        id: 27,
        href: "https://www.protocase.com/images/color/RAL-7040-Window-Grey-Smooth-Glossy.jpg",
        title: "RAL 7040 Window Gray - Glossy - Smooth Polyester Powder",
        name: "RAL 7040 Window Gray - Glossy - Smooth Polyester Powder"
    },
    {
        id: 28,
        href: "https://www.protocase.com/images/color/Federal_Standard_595.jpg",
        title: "FS 26307 Gray - Semi Gloss - Smooth Polyester Polyurethane",
        name: "FS 26307 Gray - Semi Gloss - Smooth Polyester Polyurethane"
    },


    {
        id: 29,
        href: "https://www.protocase.com/images/color/RAL-7035-Light-Gray.jpg",
        title: "RAL 7035 Light Gray - Low Gloss - Sandtex Polyester Powder",
        name: "RAL 7035 Light Gray - Low Gloss - Sandtex Polyester Powder"
    },

    {
        id: 30,
        "href": "https://www.protocase.com/images/color/RILSAN 7280 Grey.svg",
        "title": "RILSAN 7280 Grey - Nylon11 Powdercoat",
        "name": "RILSAN 7280 Grey - Nylon11 Powdercoat"
    },

    {
        id: 29,
        href: "https://www.protocase.com/images/color/ANSI70(SmoothSemiGloss).gif",
        title: "ANSI 70 Gray - Gloss - Smooth Polyester Powder",
        name: "ANSI 70 Gray - Gloss - Smooth Polyester Powder"
    },


    {
        id: 30,
        href: "https://www.protocase.com/images/color/ANSI61(SmoothSemiGloss).gif",
        title: "ASA 61 Gray - Gloss - Smooth Polyester Powder",
        name: "ASA 61 Gray - Gloss - Smooth Polyester Powder"
    },



    {
        id: 31,
        href: "https://www.protocase.com/images/color/Retro(SmoothSemiGloss).gif",
        title: "Retro Gray - Medium Gloss - Smooth Polyester Powder",
        name: "Retro Gray - Medium Gloss - Smooth Polyester Powder"
    },
    // C241-GR484 Gray - Semi Gloss Polyester Texture
    {
        id:39,
        href: "https://www.protocase.com/images/color/C241-GR484%20Dark%20Gray.svg",
        title: "C241-GR484 Gray - Semi Gloss Polyester Texture",
        name: "C241-GR484 Gray - Semi Gloss Polyester Texture"
    },
    {
        id: 32,
        href: "https://www.protocase.com/images/color/GraphiteSandtex.gif",
        title: "Graphite Sandtex - Low Gloss - Sandtex Polyester Powder",
        name: "Graphite Sandtex - Low Gloss - Sandtex Polyester Powder"
    },

    {
        id: 33,
        "href": "https://www.protocase.com/images/color/T209-CL01 Clear.svg",
        "title": "T209-CL01 Clear - Low Cure Gloss Polyester Powder",
        "name": "T209-CL01 Clear - Low Cure Gloss Polyester Powder"
    },
    {
        id: 34,
        "href": "https://www.protocase.com/images/color/PPB-4761 Fog Clear.svg",
        "title": "PPB-4761 Fog Clear - Satin Finish",
        "name": "PPB-4761 Fog Clear - Satin Finish"
    },
    {
        id: 35,
        "href": "https://www.protocase.com/images/color/Resicoat  EL HGD47QF ECA-1283 Red.svg",
        "title": "Resicoat® EL HGD47QF ECA-1283 - Red 3332",
        "name": "Resicoat® EL HGD47QF ECA-1283 - Red 3332"
    },
    {
        id: 36,
        "href": "https://www.protocase.com/images/color/Resicoat EL HNF35QF ECB-1363A.svg",
        "title": "Resicoat® EL HNF35QF ECB-1363A - Black 2701",
        "name": "Resicoat® EL HNF35QF ECB-1363A - Black 2701"
    },

    {
        id: 37,
        title: "Other",
        name: "Other"
    },
    {
        id: 38,
        title: "Not Sure",
        name: "Not Sure"
    }

]

export const materialFinishOptionsByType = {
    bareMetal: typeMaterialFinishBareMetal,
    powderCoat: typeMaterialFinishPowderCoat,
}

export const typeMaterialAluminumOnly = [
    { id: 0, title: 'Chemical Conversion Coating' },
    { id: 1, title: 'Anodizing' },
]
export const typeMaterialStainlessSteelOnly = [
    { title: 'Passivation', },
]
export const typeMaterialCopperOnly = [
    { title: 'Tin Plating', },
]

export const additionalFinishByMaterialType = {
    aluminum: typeMaterialAluminumOnly,
    stainlessSteel: typeMaterialStainlessSteelOnly,
    copper: typeMaterialCopperOnly,
};